export const GETALL_TASK_AXIOS = "GETALL_TASK_AXIOS";
export const ADD_TASK_AXIOS = "ADD_TASK_AXIOS";
export const DELETE_TASK_AXIOS = "DELETE_TASK_AXIOS";
export const DONE_TASK_AXIOS = "DONE_TASK_AXIOS";
export const REJECT_TASK_AXIOS = "REJECT_TASK_AXIOS";
